import { callGetAPI } from "./API-Calling-service";
const API_URL = process.env.REACT_APP_CHANGEINITIATION_API_URL + "WorkType" ;//process.env.REACT_APP_WORKTYPE_API_URL;
//const axios = require("axios");

export async function getWorktype() {
  return callGetAPI(API_URL);
  // return fetch(API_URL).then((response) => response.json());
}